import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class IconService {
  private readonly iconPath = 'assets/icons/';
  private readonly registeredIcons: Set<string> = new Set();

  constructor(
    private readonly iconRegistry: MatIconRegistry, 
    private readonly sanitizer: DomSanitizer
  ) {}

  registerIcon(iconName: string) {
    if (!this.registeredIcons.has(iconName)) {
      this.iconRegistry.addSvgIcon(iconName, this.sanitizer.bypassSecurityTrustResourceUrl(this.iconPath + iconName + '.svg'));
      this.registeredIcons.add(iconName);
    }
  }

   
}
